import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as homeActions from '../../redux/homeActions';
import { bindActionCreators } from 'redux';
import './UserGuide.scss';
import ReactJoyride, { EVENTS, STATUS } from 'react-joyride';
import { string } from '../../localization';
import { Icons } from '../../utilities';
import * as Constants from '../../utilities/constants/Constants';
import * as gaHelpers from '../../utilities/GAHelpers/GAHelpers';
import * as sideBarTimeUtiles from '../../utilities/TimerUtils/SidebarTimerUtils';
import { isSignageSuiteProduct } from '../../utilities/HelperFunctions/HelperFunctions';

class UserGuide extends Component {
  state = {};

  handleCheckBox = e => {
    localStorage.setItem('showHelpWindow', e.target.checked);
  };

  Tooltip = ({
    index,
    step,
    size,
    isLastStep,
    skipProps,
    primaryProps,
    tooltipProps
  }) => {
    const { handleHelpCheckBox, envData } = this.props;

    return (
      <div {...tooltipProps}>
        {index === 0 ? (
          <div id='help-feature'>
            <div className='d-flex justify-content-end'>
              <div {...skipProps} className='header' id='close' />
            </div>
            <div className='body'>
              <p className='title'>{string.LEARN_THE_BASICS_KEY}</p>
              <p className='description'>{string.TOUR_DESCRIPTION_TEXT}</p>
              <div className='d-flex justify-content-between'>
                <div id='close' {...skipProps} className='skip button'>
                  {string.SKIP_KEY}
                </div>
                <div id='next' {...primaryProps} className='start-tour button'>
                  {string.START_TOUR_KEY}
                </div>
              </div>
            </div>

            {handleHelpCheckBox ? (
              <div className='d-flex pt-3'>
                <div className='pl-4 pr-2'>
                  <input
                    type='checkbox'
                    value={localStorage.getItem('showHelpWindow')}
                    onChange={e => this.handleCheckBox(e)}
                  />
                </div>
                <div className='dont-show-text'>
                  {string.DONT_SHOW_ALERT_KEY}
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          <div
            className={`joyride-container ${
              index === 1 || (envData.is_vanilla_designer && index === 3)
                ? 'd-flex flex-column-reverse'
                : null
            }`}
          >
            <div
              className={`help-instruction ${
                step.key === 'help-settings'
                  ? 'help-instruction-settings'
                  : null
              }`}
            >
              <div>{step.content}</div>
              <div className='d-flex'>
                <div className='next-button steps'>
                  {index}/{size - 1}
                </div>
                <div {...primaryProps} className='next-button' id='next'>
                  {isLastStep
                    ? string.GOT_IT_MESSAGE_KEY
                    : `${string.NEXT_BUTTON_TITLE_KEY} ${Constants.NEXT_STEP_ARROW}`}
                </div>
              </div>
            </div>
            <div className={step.classForArrow}>
              <img className='help-arrow-size' src={step.arrow} alt='sidebar' />
            </div>
          </div>
        )}
      </div>
    );
  };

  setBackdropColor = () => {
    const { envData } = this.props;
    if (envData.is_vanilla_designer) {
      return 'rgba(0, 0, 0, 0.4)';
    }
    return 'rgba(0, 0, 0, 0.8)';
  };

  getTextContentForFirstStep = () => {
    const { envData } = this.props;
    if (envData.is_vanilla_designer) {
      return string.HELPER_TITLE_KEY_1;
    }
    return string.BASIC_HELPER_INSTRUCTION1_KEY;
  };

  getTextContentForLastStep = () => {
    const { envData } = this.props;
    if (envData.is_vanilla_designer) {
      return string.HELPER_TITLE_KEY_4;
    }
    return string.BASIC_HELPER_INSTRUCTION4_KEY;
  };

  handleJoyrideCallback = data => {
    const { type, index } = data;
    const { dispatchers, handleHelpCheckBox } = this.props;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      // this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    }
    if ([EVENTS.STEP_AFTER].includes(type) && index === 1) {
      dispatchers.gaHelpers.startAndFinishTourGA(
        Constants.GA_EVENT_ACTIONS.START_TOUR_GUIDE
      ); // Google Analytics: Start tour guide
    }

    if ([EVENTS.TOUR_END, STATUS.SKIPPED, STATUS.FINISHED].includes(type)) {
      dispatchers.gaHelpers.startAndFinishTourGA(
        Constants.GA_EVENT_ACTIONS.FINISH_TOUR_GUIDE
      ); // Google Analytics: Finish tour guide
      dispatchers.fabricCanvasActions.showHelperWindow(false);
      dispatchers.fabricCanvasActions.handleHelpCheckBox(true);
      if (handleHelpCheckBox) {
        dispatchers.timer.startTimer();
      }
    }
  };

  getStepsArray = () => {
    const { envData } = this.props;
    const steps = [
      {
        key: 'body',
        arrow: null,
        classForArrow: null,
        placement: 'center',
        disableOverlayClose: true,
        target: 'body',
        styles: {
          options: {
            overlayColor: this.setBackdropColor()
          }
        }
      },

      {
        key: 'sidebar',
        arrow: Icons.arrow_sidebar,
        classForArrow: 'sidebar-arrow',
        content: this.getTextContentForFirstStep(),
        placement: 'right-start',
        styles: {
          options: {
            arrowColor: 'transparent',
            overlayColor: this.setBackdropColor()
          },
          spotlight: {
            borderRadius: 0
          }
        },
        spotlightPadding: 0,
        disableOverlayClose: true,
        hideBackButton: true,
        target: '#sidebar',
        title: 'Our projects'
      },

      {
        key: 'help-settings',
        arrow: Icons.arrow_settings,
        classForArrow: 'setting-arrow',
        content: string.CHANGE_YOUR_SETTINGS_KEY,
        target: '#help-settings',
        placement: 'top',
        styles: {
          options: {
            arrowColor: 'transparent',
            overlayColor: this.setBackdropColor()
          },
          spotlight: {
            borderRadius: 0
          }
        },
        disableOverlayClose: true,
        spotlightPadding: 0
      },

      {
        key: 'help-next',
        arrow: Icons.arrow_next,
        classForArrow: 'next-arrow',
        content: this.getTextContentForLastStep(),
        target: '#help-next',
        placement: 'top',
        styles: {
          options: {
            arrowColor: 'transparent',
            overlayColor: this.setBackdropColor()
          },
          spotlight: {
            borderRadius: 0
          }
        },
        disableOverlayClose: true,
        spotlightPadding: 0
      }
    ];
    const mywork = {
      key: 'help-my-work-icon',
      arrow: Icons.arrow_mywork,
      classForArrow: 'mywork-arrow',
      content: string.HELPER_TITLE_KEY_3,
      target: '#help-my-work-icon',
      placement: 'top',
      styles: {
        options: {
          arrowColor: 'transparent',
          overlayColor: this.setBackdropColor()
        },
        spotlight: {
          borderRadius: 0
        }
      },
      disableOverlayClose: true,
      spotlightPadding: 0
    };
    const threeDmodal = {
      key: 'help-dimension-template',
      arrow: Icons.arrow_next,
      classForArrow: 'dimension-template-arrow',
      content: string.BASIC_HELPER_INSTRUCTION2_KEY,
      target: '#help-dimension-template',
      placement: 'top',
      styles: {
        options: {
          arrowColor: 'transparent',
          overlayColor: this.setBackdropColor()
        },
        spotlight: {
          borderRadius: 0
        }
      },
      disableOverlayClose: true,
      spotlightPadding: 0
    };
    if (envData.is_vanilla_designer) {
      steps.splice(3, 0, mywork);
    } else if (isSignageSuiteProduct()) {
      steps.splice(2, 0, threeDmodal);
    }

    return steps;
  };

  render() {
    const { helpWindowIsVisible } = this.props;

    return (
      <div className='demo-wrapper'>
        <ReactJoyride
          continuous
          showSkipButton
          run={helpWindowIsVisible}
          steps={this.getStepsArray()}
          styles={{
            options: {
              zIndex: 10000
            }
          }}
          tooltipComponent={this.Tooltip}
          callback={this.handleJoyrideCallback}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    helpWindowIsVisible: state.fabricCanvas.helpWindowIsVisible,
    handleHelpCheckBox: state.fabricCanvas.handleHelpCheckBox,
    language: state.home.language,
    envData: state.modal.envData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      timer: bindActionCreators(sideBarTimeUtiles, dispatch),
      gaHelpers: bindActionCreators(gaHelpers, dispatch),
      homeActions: bindActionCreators(homeActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserGuide);
